import Vue from 'vue';
import { processCookies  } from '@/helpers/helpers';

export default {
  state: {
    quotesData: {},
  },
  mutations: {
    SET_QUOTES_DATA(state, quotesData) {
      state.quotesData = quotesData;
    },
    DELETE_QUOTE(state, { productName, logId }) {
      state.quotesData.quotes_details[productName] = state.quotesData.quotes_details[productName].filter((quote) => quote.logId !== logId);
    },
  },
  actions: {
    async getQuotesData ({ commit, dispatch, rootState }) {
      try {
        const data = {
          userId: rootState.user.ids,
          email: rootState.user.email,
          memberId: rootState.user.memberId,
          partner: rootState.user.partner,
        };
        
        if( rootState.user.configUserKeepSignIn ) {
          data.userKeepSignIn = rootState.user.configUserKeepSignIn
        }
        
        const response = await Vue.prototype.$api.getQuotes(data);

        if (response.status === 'success') {
          commit('SET_QUOTES_DATA', response.data);
          const cookies = await Vue.prototype.$api.getCookiesToSet();
          processCookies(cookies);
        } else {
          dispatch('showToast', {
            text: 'Something went wrong. Please, try again later',
          });
        }
      } catch (error) {
        dispatch('showToast', {
          text: 'Something went wrong. Please, try again later',
        });
      }
    },
    deleteQuote({ dispatch }, { productName, logId }) {
      dispatch('showConfirmModal', {
        yesCallback: () => {
          dispatch('deleteQuoteWithoutConfirmation', { productName, logId });
        },
      });
    },
    async deleteQuoteWithoutConfirmation({ commit, dispatch }, { productName, logId }) {
      try {
        await Vue.prototype.$api.deleteQuote(logId);
        commit('DELETE_QUOTE', { productName, logId });

        dispatch('showToast', {
          type: 'success',
          text: 'Quote deleted',
        });
      } catch (error) {
        dispatch('showToast', {
          text: 'Error deleting quote. Please, try again later',
        });
      }
    },
  },
  getters: {
    quotesData: (state) => state.quotesData,
  },
};
